import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/", label: "首页", end: true },
  { to: "/dispatch/breaking", label: "突发专报", end: false },
  { to: "/dispatch/flash", label: "紧急插播", end: false },
  { to: "/dispatch/headline", label: "头条专递", end: false },
  { to: "/dispatch/deep", label: "深度瓜情", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="瓜田速递 首页">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-black">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                瓜田速递
              </span>
              <span className="hidden sm:flex items-center gap-1 text-[10px] font-label text-foreground-500 mt-0.5">
                <i className="ri-live-line text-primary-500" aria-hidden="true"></i>
                突发专报 · 紧急插播
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden lg:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-label transition-colors whitespace-nowrap ${
                    isActive
                      ? "bg-primary-100 text-primary-700 font-medium"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <span className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-label">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-gt-pulse-dot"></span>
              实时刷新
            </span>
            <Link
              to="/#subscribe"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅瓜情
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          aria-label="移动端导航"
          className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2"
        >
          <ul className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `block px-3 py-3 rounded-md text-sm font-label border-b border-background-100 ${
                      isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/#subscribe"
            className="mt-4 flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium"
          >
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            订阅瓜情简报
          </Link>
        </nav>
      )}
    </header>
  );
}